import { useCallback, useMemo } from 'react';
import { UseQueryOptions } from '@tanstack/react-query';

import {
  api,
  UserPreference,
  UserPreferenceKey,
  UserPreferencesError,
  UserPreferencesResponse,
} from '@/api';

export function useUserPreferences(
  config?: Partial<UseQueryOptions<UserPreferencesResponse, UserPreferencesError>>,
) {
  const query = api.fct.userPreference.query.useGetUserPreferences({
    ...config,
  });

  const data = useMemo(() => {
    const raw = query.data;

    return Array.isArray(raw) ? raw : ([] as UserPreference[]);
  }, [query.data]);

  const preferencesMap = useMemo(() => new Map(data.map((pref) => [pref.key, pref])), [data]);

  const getPreference = useCallback(
    (key: UserPreferenceKey) => preferencesMap.get(key),
    [preferencesMap],
  );

  return {
    ...query,
    data,
    getPreference,
    preferencesMap,
  };
}
